import { Observable } from '../Observable';
export function fromSubscribable(subscribable) {
    return new Observable((subscriber) => subscribable.subscribe(subscriber));
}
//# sourceMappingURL=fromSubscribable.js.map